import axios from '../javascript/custom-axios'
const RESOURCE_NAME = 'criterion'

export default {
  getCriteria(page=1,pageSize=100) {
    return axios.get(`${RESOURCE_NAME}/GetList`, { params: { page: page, pageSize:pageSize } })
  },
  createCriterion(body){
    return axios.post(`${RESOURCE_NAME}/create`,body)
 
  }
}